<template>
    <div class="video-container" :style="containerStyle">
        <slot name="overlaySelecao" />
        <iframe
            class="video"
            v-if="videoUrl"
            :src="videoUrl"
            width="100%"
            height="100%"
            style="aspect-ratio: 16 / 9"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
            referrerpolicy="strict-origin-when-cross-origin"
            @error="handleIframeError"
            @load="handleIframeLoad"
        ></iframe>
        <div v-else class="video-placeholder">
            <span class="material-symbols-outlined text-primary select-none cursor-pointer" style="font-size: 36px; vertical-align: middle"
                >video_camera_back_add</span
            >
        </div>
    </div>
</template>

<script setup>
import { defineProps, computed, ref } from 'vue';

const props = defineProps({
    url: {
        type: String,
        default: '',
    },
    largura: {
        type: String,
        default: '100%',
    },
    altura: {
        type: String,
        default: '315px',
    },
});

const iframeError = ref(false);

const normalizeYouTubeUrl = (url) => {
    if (!url) return '';

    try {
        if (url.includes('youtube.com/embed/')) {
            return url;
        }

        if (url.includes('youtube.com/watch?v=')) {
            const videoId = new URL(url).searchParams.get('v');
            return `https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1`;
        }

        if (url.includes('youtu.be/')) {
            const videoId = url.split('youtu.be/')[1].split('?')[0];
            return `https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1`;
        }

        return url;
    } catch (error) {
        console.error('Erro ao normalizar URL do vídeo:', error);
        return url;
    }
};

const videoUrl = computed(() => {
    return normalizeYouTubeUrl(props.url);
});

const containerStyle = computed(() => ({
    width: props.largura,
    height: props.altura,
    minHeight: '200px',
}));

const handleIframeError = (event) => {
    console.error('Erro ao carregar vídeo:', event);
    iframeError.value = true;
};

const handleIframeLoad = () => {
    iframeError.value = false;
};
</script>

<style scoped>
.video-container {
    position: relative;
    overflow: hidden;
    background: #000;
}

.video {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.video-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: #6c757d;
    font-size: 14px;
    height: 100%;
    min-height: 200px;
    background: #f8f9fa;

    .material-symbols-outlined {
        font-size: 48px;
        opacity: 0.25;
    }
}
</style>
